import { useQuery } from '@tanstack/react-query';

import { mockList } from '@/lib/mock/db';
import { queryKeys } from '@/lib/queryKeys';
import { WidgetFrame, WidgetRow } from '@/pages/home/widgets/WidgetFrame';

/** 이번 달 입·퇴사자. 달이 바뀌면 저절로 비워진다. */

const VISIBLE_COUNT = 5;

export function EmployeeNewsWidget() {
  const monthPrefix = new Date().toISOString().slice(0, 7);

  const news = useQuery({
    queryKey: queryKeys.employeeNewsItems,
    queryFn: () => mockList('employeeNewsItems'),
    select: (items) =>
      items
        .filter((item) => item.newsDate.startsWith(monthPrefix))
        .sort((a, b) => b.newsDate.localeCompare(a.newsDate)),
  });

  const items = news.data ?? [];

  return (
    <WidgetFrame
      title="신규입사자 소식"
      icon="users"
      to="/news/employees"
      pending={news.isPending}
      error={news.error}
      empty={items.length === 0}
      emptyText="이번 달 등록된 사내 소식이 없습니다."
      headerRight={<span className="badge badge-gray">{Number(monthPrefix.slice(5))}월</span>}
    >
      <div className="space-y-0.5">
        {items.slice(0, VISIBLE_COUNT).map((item) => (
          <WidgetRow
            key={item.id}
            to="/news/employees"
            leading={
              <span className={`badge badge-sm flex-shrink-0 ${item.newsType === 'join' ? 'badge-blue' : 'badge-gray'}`}>
                {item.newsType === 'join' ? '입사' : '퇴사'}
              </span>
            }
            title={`${item.employeeName} ${item.rank ?? ''} · ${item.deptSite ?? '-'}`}
            meta={item.newsDate.slice(5).replace('-', '.')}
          />
        ))}

        {items.length > VISIBLE_COUNT && (
          <p className="pt-1 text-center text-ui-xs" style={{ color: 'var(--text-muted)' }}>
            외 {items.length - VISIBLE_COUNT}명
          </p>
        )}
      </div>
    </WidgetFrame>
  );
}
